module.exports = __webpack_public_path__ + "debc7f74444597a35029563fdd32209f.svg";